import _defineProperty from "/Users/katnoria/dev/workspaces/web/katnoria.com/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { getFirstDefined } from '../../util';
import { isVgRangeStep } from '../../vega.schema';
import { getMarkConfig } from '../common';
import * as mixins from './mixins';
import * as ref from './valueref';
export var tick = {
  vgMark: 'rect',
  encodeEntry: function encodeEntry(model) {
    var config = model.config,
        markDef = model.markDef,
        width = model.width,
        height = model.height;
    var orient = markDef.orient;
    var vgSizeChannel = orient === 'horizontal' ? 'width' : 'height';
    var vgThicknessChannel = orient === 'horizontal' ? 'height' : 'width';
    return Object.assign({}, mixins.baseEncodeEntry(model, {
      size: 'ignore',
      orient: 'ignore'
    }), mixins.pointPosition('x', model, ref.mid(width), 'xc'), mixins.pointPosition('y', model, ref.mid(height), 'yc'), mixins.nonPosition('size', model, {
      defaultValue: defaultSize(model),
      vgChannel: vgSizeChannel
    }), _defineProperty({}, vgThicknessChannel, {
      value: getFirstDefined(markDef.thickness, config.tick.thickness)
    }));
  }
};

function defaultSize(model) {
  var config = model.config,
      markDef = model.markDef;
  var orient = markDef.orient;
  var vgSizeChannel = orient === 'horizontal' ? 'width' : 'height';
  var scale = model.getScaleComponent(orient === 'horizontal' ? 'x' : 'y');
  var markPropOrConfig = getFirstDefined(markDef[vgSizeChannel], markDef.size, getMarkConfig('size', markDef, config, {
    vgChannel: vgSizeChannel
  }), config.tick.bandSize);

  if (markPropOrConfig !== undefined) {
    return markPropOrConfig;
  } else {
    var scaleRange = scale ? scale.get('range') : undefined;
    var rangeStep = scaleRange && isVgRangeStep(scaleRange) ? scaleRange.step : config.scale.rangeStep;

    if (typeof rangeStep !== 'number') {
      // FIXME consolidate this log
      throw new Error('Function does not handle non-numeric rangeStep');
    }

    return rangeStep * 3 / 4;
  }
}